import axios, { AxiosResponse } from 'axios';
import {
  URL_CONFIGURE_SHIPPING_CARRIER,
  URL_SHIPPING_CARRIER_VALIDATE_CONFIGURATION,
  URL_GENERATE_PDF_TRACKING_NUMBERS,
  URL_SHIPPING,
  URL_ORDER_DELIVERY
} from 'constants/url';
import useUser from 'hooks/useUser';
import { IGeneratePdf } from 'interfaces/order.interface';
import { IOrderShippingRequest } from 'interfaces/orderPackages.interface';
import { IShippingRequest, IShippingResponse } from 'interfaces/shipping.interface';
import { IConfiguration } from 'interfaces/shippingCarrier.interface';
import { downloadPDF } from 'utils/downloadPDF';

export async function getRate() {
  return axios.get(URL_CONFIGURE_SHIPPING_CARRIER).then((result: AxiosResponse) => {
    return result.data;
  });
}

export const isConfigurationComplete = (): Promise<boolean> => new Promise((resolve) => resolve(false));

export default function useShippingCarrier() {
  const { jwt, setIsConfigurationComplete } = useUser();

  async function getConfiguration(): Promise<IConfiguration> {
    return axios
      .get(URL_CONFIGURE_SHIPPING_CARRIER, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })
      .then((result: AxiosResponse) => {
        return result.data;
      });
  }

  async function saveConfiguration(data: IConfiguration): Promise<boolean> {
    return axios
      .put(`${URL_CONFIGURE_SHIPPING_CARRIER}/${data.id}`, data, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })
      .then(() => {
        setIsConfigurationComplete(true);
        return true;
      });
  }

  async function isConfigurationComplete(): Promise<boolean> {
    return axios
      .get(URL_SHIPPING_CARRIER_VALIDATE_CONFIGURATION, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })
      .then((result: AxiosResponse) => {
        return result.data?.isDone;
      });
  }

  async function createTrackingId(data: IShippingRequest | IOrderShippingRequest): Promise<IShippingResponse> {
    return new Promise((resolve, reject) => {
      axios
        .post<IShippingResponse>(`${URL_SHIPPING}`, data, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })
        .then((response) => {
          if (response.status === 201 && response.data.trackingId) {
            resolve(response.data);
          } else {
            reject('Respuesta no esperada');
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async function createTrackingDelivery(data: IShippingRequest | IOrderShippingRequest): Promise<IShippingResponse> {
    return new Promise((resolve, reject) => {
      axios
        .post<IShippingResponse>(`${URL_ORDER_DELIVERY}`, data, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })
        .then((response) => {
          if (response.status === 201 && response.data.trackingId) {
            resolve(response.data);
          } else {
            reject('Respuesta no esperada');
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async function generatePdfOfShippings(generatePdfInfo: IGeneratePdf, labelId: string): Promise<string> {
    generatePdfInfo.labelId = labelId;

    return axios
      .post(`${URL_GENERATE_PDF_TRACKING_NUMBERS}`, generatePdfInfo, {
        headers: {
          Authorization: `Bearer ${jwt}`
        }
      })
      .then((response: AxiosResponse) => {
        if (response.data.pdfCoordinadora && response.data.pdfQr) {
          downloadPDF(response.data.pdfCoordinadora, 'reImpresión_de_guias_coordinadora.pdf');
          downloadPDF(response.data.pdfQr, 'reImpresión_de_guias_qr.pdf');
        } else if (response.data.pdfCoordinadora) {
          downloadPDF(response.data.pdfCoordinadora, 'reImpresión_de_guias_coordinadora.pdf');
        } else {
          downloadPDF(response.data.pdfQr, 'reImpresión_de_guias_qr.pdf');
        }
        return response.data;
      });
  }

  return {
    getConfiguration,
    saveConfiguration,
    isConfigurationComplete,
    createTrackingId,
    createTrackingDelivery,
    generatePdfOfShippings
  };
}
